import axios from 'axios'

import {
    ACCOUNT_REGISTER_REQUEST,
    ACCOUNT_REGISTER_SUCCESS,
    ACCOUNT_REGISTER_FAIL
} from '../constants/accountConstants'
import { trackEvent } from '../analytics/ga4'

//account register action
export const register = (email, password) => async(dispatch) => {
    try{
        dispatch({type:ACCOUNT_REGISTER_REQUEST})

        const config = { headers:{'Content-type':'application/json'}}
        const {data} = await axios.post(process.env.REACT_APP_URL + '/api/account/create',
                                        {'email':email,
                                          'password':password}, config)


        dispatch({type:ACCOUNT_REGISTER_SUCCESS, payload:data})
        trackEvent('sign_up_pending', { method: 'email' })

        localStorage.setItem('accountInfo', JSON.stringify(data))
    }catch{
        dispatch({
            type:ACCOUNT_REGISTER_FAIL, payload:'入力したEメールアドレスは既に別のユーザが使用しています'
        })
    }
}
